'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useState } from 'react';
export type FrictionState = 'landing' | 'mock-app' | 'exit-sheet';

// Minimal CloseWatcher type declaration (not yet in all TS lib.dom.d.ts versions)
declare class CloseWatcher extends EventTarget {
  destroy(): void;
}
export function useBackButtonFriction() {
  const $ = _c(6);
  const [frictionState, setFrictionState] = useState("landing");
  let t0;
  let t1;
  if ($[0] !== frictionState) {
    t0 = () => {
      if (typeof window === "undefined" || !("CloseWatcher" in window)) {
        return;
      }
      const watcher = new CloseWatcher();
      watcher.addEventListener("close", () => {
        if (frictionState === "landing") {
          setFrictionState("mock-app");
        } else {
          if (frictionState === "mock-app") {
            setFrictionState("exit-sheet");
          } else {
            if (frictionState === "exit-sheet") {
              window.history.back();
              window.close();
            }
          }
        }
      });
      return () => watcher.destroy();
    };
    t1 = [frictionState];
    $[0] = frictionState;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setFrictionState("landing");
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const returnToLanding = t2;
  const exitApp = _temp;
  let t3;
  if ($[4] !== frictionState) {
    t3 = {
      frictionState,
      returnToLanding,
      exitApp
    };
    $[4] = frictionState;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}
function _temp() {
  window.history.back();
  window.close();
}